export const MINFWVER_ACSCHEDULES_RBE24 = "2.1.00";

// GROUP 
export enum GROUP_TABLE_COLUMNS {
    NAME = 'Name',
    TIMESLOT = 'Timeslot',
    SPECIALPERIOD = 'SpecialPeriod',
    ACTIONS = 'Actions',
}

export const GROUP_DEFAULT_SORT_COLUMN = GROUP_TABLE_COLUMNS.NAME;
export const GROUP_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
// export const GROUP_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const GROUP_PAGE_DEFAULT_SIZE = 5;
// export const GROUP_MAX_MEMORY_SIZE = 20;

export const GROUP_TABLE_HEADER = [
    GROUP_TABLE_COLUMNS.NAME,
    GROUP_TABLE_COLUMNS.TIMESLOT,
    GROUP_TABLE_COLUMNS.SPECIALPERIOD,
    GROUP_TABLE_COLUMNS.ACTIONS,
];


// WEEKLY_SCHEDULE 
export enum WEEKLY_SCHEDULE_TABLE_COLUMNS {
    NAME = 'Name',
    TYPE = 'Type',
    REPETITION = 'Repetition',
    INCLUDEEXCLUDE = 'IncludeExclude',
    DETAILS = 'Details',
    TIME = 'Time',
    TEMPORARY = 'Temporary',
    ACTIONS = 'Actions',
}

export const WEEKLY_SCHEDULE_DEFAULT_SORT_COLUMN = WEEKLY_SCHEDULE_TABLE_COLUMNS.NAME;
export const WEEKLY_SCHEDULE_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
// export const WEEKLY_SCHEDULE_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const WEEKLY_SCHEDULE_PAGE_DEFAULT_SIZE = 5;

export const WEEKLY_SCHEDULE_TABLE_HEADER = [
    WEEKLY_SCHEDULE_TABLE_COLUMNS.NAME,
    WEEKLY_SCHEDULE_TABLE_COLUMNS.TYPE,
    WEEKLY_SCHEDULE_TABLE_COLUMNS.REPETITION,
    WEEKLY_SCHEDULE_TABLE_COLUMNS.INCLUDEEXCLUDE,
    WEEKLY_SCHEDULE_TABLE_COLUMNS.DETAILS,
    WEEKLY_SCHEDULE_TABLE_COLUMNS.TIME,
    WEEKLY_SCHEDULE_TABLE_COLUMNS.TEMPORARY,
    WEEKLY_SCHEDULE_TABLE_COLUMNS.ACTIONS,
];

//SPECIAL_PLANNING
export enum SPECIAL_PLANNING_TABLE_COLUMNS {
    NAME = 'name',
    PROGRAM = 'program',
    ACTIONS = 'actions',
}

export const SPECIAL_PLANNING_DEFAULT_SORT_COLUMN = SPECIAL_PLANNING_TABLE_COLUMNS.NAME;
export const SPECIAL_PLANNING_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
// export const SPECIAL_PLANNING_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const SPECIAL_PLANNING_PAGE_DEFAULT_SIZE = 5;
// export const SPECIAL_PLANNING_MAX_MEMORY_SIZE = 20;

export const SPECIAL_PLANNING_TABLE_HEADER = [
    SPECIAL_PLANNING_TABLE_COLUMNS.NAME,
    SPECIAL_PLANNING_TABLE_COLUMNS.PROGRAM,
    SPECIAL_PLANNING_TABLE_COLUMNS.ACTIONS,
];


export const WEEKDAYS_STRING_ID = [
    'WEEKDAY_MONDAY',
    'WEEKDAY_TUESDAY',
    'WEEKDAY_WEDNESDAY',
    'WEEKDAY_THURSDAY',
    'WEEKDAY_FRIDAY',
    'WEEKDAY_SATURDAY',
    'WEEKDAY_SUNDAY',
]